
<template>

	<b-modal :id="id" size="xl" v-on:show="reset" v-on:hidden="reset" title="Экспорт в табличное представление" v-on:ok="ok" ok-title="Экспортировать" cancel-title="Отменить" no-close-on-backdrop cancel-variant="outline-primary-secondary">

		<form @submit.stop.prevent="submit">

			<attr_many_select :attrs="attrs" :attrs_visible="attrs_visible" v-model="attrs_selected"/>

			<b-row class="mt-2">

				<b-col cols="2">Формат:</b-col>
				<b-col>

					<b-form-radio-group v-model="format">

						<b-form-radio value="csv">CSV</b-form-radio>
						<b-form-radio value="xlsx">XLSX</b-form-radio>

					</b-form-radio-group>

				</b-col>

			</b-row>

		</form>

	</b-modal>

</template>

<script>

import { uuid } from "vue-uuid"
import api from "../../../api"
import attr_many_select from "../../widgets/attr_many_select"

export default
{
	components :
	{
		attr_many_select
	},

	data()
	{
		return {
			
			id : uuid.v1(),

			attrs : [],
			attrs_visible : [],
			attrs_selected : [],

			format : "xlsx",

		}
	},

	methods :
	{
		reset()
		{
			this.attrs = api.sort_objects_array_by_key(this.$parent.attrs, "name") // .filter(attr => ! attr.not_real), "name")
			this.attrs_visible = this.attrs.filter(attr => this.$parent.attrs_visible.find(attr_visible => attr_visible.key == attr.key) != null)
			this.attrs_selected = []
			this.format = "xlsx"
		},

		execute()
		{
			this.$bvModal.show(this.id)
		},

		ok(event)
		{
			event.preventDefault()
			this.submit()
		},

		check()
		{
			return true
		},

		submit()
		{
			if(! this.check())
				return;

			const params = {
				
				type : "table",
				attrs : this.attrs_selected,
				query : this.$parent.get_query(),
				format : this.format,

			}

			api.call_long_operation(this, "Экспорт запущен", this.$parent.service, "export", params, api.open_response_url, { success_msg : "Экспорт таблицы завершен" })
			
			this.$nextTick(() => { this.$bvModal.hide(this.id, "modal-prevent-closing") })
		}
	}
}

</script>

